<template>
  <div class="relative">
    <button
      @click="toggleDropdown"
      class="flex items-center space-x-1 text-sm text-gray-600 hover:text-gray-900 transition-colors"
    >
      <span class="flag-icon" :class="`flag-icon-${currentLocale === 'de' ? 'de' : 'gb'}`"></span>
      <span class="font-medium">{{ currentLocale.toUpperCase() }}</span>
      <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
      </svg>
    </button>

    <transition name="dropdown">
      <div 
        v-if="showDropdown"
        class="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg py-1 ring-1 ring-black ring-opacity-5 z-50"
      >
        <button
          @click="changeLanguage('de')"
          class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          :class="{ 'font-semibold': currentLocale === 'de' }"
        >
          <span class="flag-icon flag-icon-de mr-2"></span>
          Deutsch
        </button>
        <button
          @click="changeLanguage('en')"
          class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          :class="{ 'font-semibold': currentLocale === 'en' }"
        >
          <span class="flag-icon flag-icon-gb mr-2"></span>
          English
        </button>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { usePage } from '@inertiajs/vue3'

const page = usePage()
const showDropdown = ref(false)

const currentLocale = computed(() => {
  return page.props.locale || 'de'
})

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value
}

const changeLanguage = (locale: string) => {
  showDropdown.value = false
  
  // Direct navigation to language switching route for full page reload
  window.location.href = `/language/${locale}`
}

const closeDropdown = (event: Event) => {
  if (!(event.target as Element).closest('.relative')) {
    showDropdown.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeDropdown)
})

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown)
})
</script>

<style>
@import 'flag-icons/css/flag-icons.min.css';

.flag-icon {
  width: 1.33em;
  height: 1em;
}

.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.2s ease;
}
.dropdown-enter-from, .dropdown-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>